import { render, staticRenderFns } from "./ItemsQuotationImport.vue?vue&type=template&id=31afedfd&scoped=true"
import script from "./ItemsQuotationImport.vue?vue&type=script&lang=js"
export * from "./ItemsQuotationImport.vue?vue&type=script&lang=js"
import style0 from "./ItemsQuotationImport.vue?vue&type=style&index=0&id=31afedfd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31afedfd",
  null
  
)

export default component.exports